import {MenuItem} from './menu.model';

export const MENU: MenuItem[] = [];

